import store from '@/store/store';
import { trackEvent } from '@/plugins/mixpanel';
import { getBenchmarkId, getPlanId } from '@/utils';

export const trackEventWithUserProperties = (eventName, properties = {}) => {
  const planId = getPlanId();
  const benchmarkId = getBenchmarkId();

  const newProperties = {
    planId,
    benchmarkId,
    ...properties,
  };

  trackEvent(eventName, newProperties);
};

export const dispatchMixpanelTrack = (trackName, propsList = [], customProps = {}) => {
  const defaultProps = {
    network: store.state.ui.channel,
    tab: store.state.ui.tabName,
    groups: store.state.ui.groupList.map(({ id, title }) => ({ id, title })),
    email: store.state.user.user.email,
  };

  const dynamicProps = propsList.reduce((acc, p) => {
    if (p in defaultProps) {
      acc[p] = defaultProps[p];
    }

    return acc;
  }, {});

  const props = {
    ...dynamicProps,
    ...customProps,
  };

  trackEventWithUserProperties(trackName, props);
};
